document.addEventListener("DOMContentLoaded", () => {
  const links = document.querySelectorAll('a[target="_blank"]');

  links.forEach((link) => {
    // Get existing aria-label or default to empty string
    let currentLabel = link.getAttribute("aria-label") || "";

    // Avoid duplicating the message if already added
    if (!currentLabel.includes("Opens in New Tab")) {
      // Add or append the "Opens in New Tab" label
      const newLabel = currentLabel
        ? `${currentLabel}. Opens in New Tab`
        : "Opens in New Tab";

      link.setAttribute("aria-label", newLabel);
    }
  });
});
